'use client'

import { signOut } from 'next-auth/react'
import { useTheme } from 'next-themes'
import Link from 'next/link'

import { UserAvatar } from '@components/ui/avatar'
import * as DropdownMenu from '@components/ui/dropdown-menu'
import { DOCS_URL } from '@lib/constants'
import { logoutBeacon } from '@lib/help-scout-beacon'
import { useAppRoute } from '@lib/use-app-route'
import { useMe } from '@resolvers/auth'

export const AccountMenuItems = () => {
  const { teamPath } = useAppRoute()
  const { theme, setTheme } = useTheme()

  return (
    <>
      <DropdownMenu.Item asChild>
        <Link href={teamPath('/account')}>Account</Link>
      </DropdownMenu.Item>
      <DropdownMenu.Item asChild>
        <a href={DOCS_URL} target="_blank" rel="noreferrer">
          Docs
        </a>
      </DropdownMenu.Item>
      <DropdownMenu.Sub>
        <DropdownMenu.SubTrigger>Appearance</DropdownMenu.SubTrigger>
        <DropdownMenu.SubContent className="w-[150px] rounded-xl bg-o-card text-[13px]">
          <DropdownMenu.RadioGroup value={theme} onValueChange={setTheme}>
            <DropdownMenu.RadioItem value="light">Light</DropdownMenu.RadioItem>
            <DropdownMenu.RadioItem value="dark">Dark</DropdownMenu.RadioItem>
            <DropdownMenu.RadioItem value="system">System</DropdownMenu.RadioItem>
          </DropdownMenu.RadioGroup>
        </DropdownMenu.SubContent>
      </DropdownMenu.Sub>
      <DropdownMenu.Item
        onSelect={() => {
          logoutBeacon()
          signOut({ callbackUrl: '/login' })
        }}
      >
        Sign out
      </DropdownMenu.Item>
    </>
  )
}

const UserMenu = () => {
  const { me } = useMe()
  const user = me?.user

  return (
    <DropdownMenu.Root modal={false}>
      <DropdownMenu.Trigger asChild>
        <button
          type="button"
          aria-label="Account menu"
          className="flex w-full items-center gap-2.5 rounded-lg px-2.5 py-2 text-start outline-hidden hover:bg-o-chip data-[state=open]:bg-o-chip"
        >
          <UserAvatar name={user?.name} email={user?.email} image={user?.avatar} size={26} priority className="rounded-full" />
          <span className="flex min-w-0 flex-col">
            <span className="truncate text-sm text-o-ink">{user?.name || user?.email}</span>
            {user?.name && <span className="truncate text-xs text-o-muted">{user.email}</span>}
          </span>
        </button>
      </DropdownMenu.Trigger>
      <DropdownMenu.Content align="start" side="top" sideOffset={8} className="w-[228px] rounded-xl bg-o-card text-[13px]">
        <div className="py-1">
          <AccountMenuItems />
        </div>
      </DropdownMenu.Content>
    </DropdownMenu.Root>
  )
}

export default UserMenu
